import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/team/skills')({
  component: () => <PageStub title="Skills Matrix" description="Team skills and competencies" />,
});
